// extracted by css-extract-rspack-plugin
export default {"loading":"loading-a0qepo","results":"results-IBMscW"};